module.exports = __webpack_public_path__ + "img/[嘴唇].2abb2fdb.svg";